import {Parameter, ToolboxScaleScale} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import OrientationEnum from "./OrientationEnum";

export class PortalToolboxScaleScale extends ToolboxScaleScale implements Parameter {
	public format?: string;
	public orientation?: OrientationEnum;

	constructor(data: any) {
		super(data);

		this.format = FunctionHelper.exists(data?.format) ? data.format : "A4";
		this.orientation = FunctionHelper.exists(data?.orientation) ? data.orientation : OrientationEnum.VERTICAL;
	}

	public static getFormatDefault(): string {
		return "A4";
	}

	public static getOrientationDefault(): OrientationEnum {
		return OrientationEnum.VERTICAL;
	}

	public static fromJson(data: any): PortalToolboxScaleScale {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalToolboxScaleScale(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'format': this.format,
			'orientation': this.orientation
		};
	}

	public clone(): PortalToolboxScaleScale {
		return PortalToolboxScaleScale.fromJson(this.toJson());
	}
}